interface IPromotion {
  creative_name?: string;
  creative_slot?: string;
  promotion_id?: string;
  promotion_name?: string;
}

export const trackViewPopUp = ({
  creative_name,
  creative_slot,
  promotion_id,
  promotion_name,
}: IPromotion) => {
  if (typeof window === 'undefined') return;

  (window as any)?.dataLayer?.push({ ecommerce: null });
  (window as any)?.dataLayer?.push({
    event: 'view_promotion',
    ecommerce: {
      items: [
        {
          creative_name: creative_name || 'not available',
          creative_slot: creative_slot || 'not available',
          promotion_id: promotion_id || 'not available',
          promotion_name: promotion_name || 'not available',
        },
      ],
    },
  });
};

export const trackSelectPopUp = ({
  creative_name,
  creative_slot,
  promotion_id,
  promotion_name,
}: IPromotion) => {
  if (typeof window === 'undefined') return;

  (window as any)?.dataLayer?.push({ ecommerce: null });
  (window as any)?.dataLayer?.push({
    event: 'select_promotion',
    ecommerce: {
      items: [
        {
          creative_name: creative_name || 'not available',
          creative_slot: creative_slot || 'not available',
          promotion_id: promotion_id || 'not available',
          promotion_name: promotion_name || 'not available',
        },
      ],
    },
  });
};
